import React from 'react';
import { Select } from 'antd';
import BillingRules from '../../billing/BillingRules';
import { getCustomerList } from '../../../services/project';

const AdminBillingRulesPage: React.FC = () => {
  const [customerOptions, setCustomerOptions] = React.useState<Array<{ value: number; label: string }>>([]);
  const [selectedCustomerId, setSelectedCustomerId] = React.useState<number | undefined>(() => {
    try {
      const url = new URL(window.location.href);
      const qcid = url.searchParams.get('customer_id');
      return qcid ? Number(qcid) : undefined;
    } catch {
      return undefined;
    }
  });

  React.useEffect(() => {
    (async () => {
      try {
        const list = await getCustomerList({ onlyMain: true });
        const opts = Array.isArray(list)
          ? list.map((c: any) => ({ value: Number(c.id), label: `${c.customer_code || c.id || ''} - ${c.name || c.username || ''}` }))
          : [];
        setCustomerOptions(opts);
      } catch {
        setCustomerOptions([]);
      }
    })();
  }, []);

  const handleCustomerChange = (cid?: number) => {
    setSelectedCustomerId(cid);
    try {
      const url = new URL(window.location.href);
      if (cid) url.searchParams.set('customer_id', String(cid)); else url.searchParams.delete('customer_id');
      // 清除已选项目，避免跨客户污染
      url.searchParams.delete('project_id');
      window.history.replaceState({}, '', url.toString());
    } catch {}
  };

  return (
    <div className="p-6">
      <BillingRules
        key={`cid-${selectedCustomerId || 'none'}`}
        extraFiltersStart={(
          <Select
            allowClear
            placeholder="客户（主账号）"
            style={{ width: 320 }}
            value={selectedCustomerId}
            options={customerOptions}
            showSearch
            optionFilterProp="label"
            onChange={(v) => handleCustomerChange(v as number | undefined)}
          />
        )}
      />
    </div>
  );
};

export default AdminBillingRulesPage;


